import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { loadWasms } from '@app/store/actions/emoji';
import { WasmType } from '@app/store/types/emoji';

export function useGetParamsFromSearchQuery(searchQuery = '') {
    const wasm = useAppSelector((state) => state.emoji.wasm);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!wasm) {
            dispatch(loadWasms(WasmType.EmojiWasm));
        }
    }, [wasm, dispatch]);

    if (!wasm) return {};

    if (wasm?.is_valid_emoji_id(searchQuery)) {
        return { emoji: searchQuery };
    }

    let text = searchQuery;
    // Remove initial @ for twitter handle search
    if (text[0] === '@') {
        text = text.replace('@', '');
    }

    return { text };
}
